exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".clanblack[data-v-53639c3b]{font-family:ClanFFBlack!important;font-weight:400}.clanpro[data-v-53639c3b]{font-family:ClanPro!important;font-weight:400}.clanprobold[data-v-53639c3b]{font-family:ClanProBold!important;font-weight:400}.clanprobook[data-v-53639c3b]{font-family:ClanProBook!important;font-weight:400}.username[data-v-53639c3b]{font-size:13px;color:#999}h1[data-v-53639c3b]{margin-top:5px}.ibox[data-v-53639c3b]{margin-bottom:10px}.ibox .ibox-content dl[data-v-53639c3b]{font-size:13px}.ibox a[data-v-53639c3b]{color:#000}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-53639c3b","scoped":true,"hasInlineConfig":false}!./node_modules/sass-loader/lib/loader.js?{"silenceDeprecations":["legacy-js-api","import","global-builtin","color-functions","slash-div"],"quietDeps":true}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/HomeMobile.vue
// module id = 721
// module chunks = 0